<app-layout>
    <div class="main-container">
        <div class="menu">
            <mat-list>
                <h6 mat-subheader>{{ 'Benefits' | translate: {Default: "Benefits"} }}</h6>
                <mat-list-item *ngFor="let item of navList" [routerLink]="item.link" routerLinkActive="active">
                  <div>{{item.text}}</div>
                </mat-list-item>
            </mat-list>
        </div>
        <div class="content">
            <div class="main-content">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</app-layout>
